/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ConvoDefs from './defs.defs.js'

const $nsid = 'chat.bsky.convo.getLog'

export { $nsid }

const main = l.query(
  $nsid,
  l.params({ cursor: l.optional(l.string()) }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    logs: l.array(
      l.typedUnion(
        [
          l.typedRef<ConvoDefs.LogBeginConvo>(
            (() => ConvoDefs.logBeginConvo) as any,
          ),
          l.typedRef<ConvoDefs.LogAcceptConvo>(
            (() => ConvoDefs.logAcceptConvo) as any,
          ),
          l.typedRef<ConvoDefs.LogLeaveConvo>(
            (() => ConvoDefs.logLeaveConvo) as any,
          ),
          l.typedRef<ConvoDefs.LogMuteConvo>(
            (() => ConvoDefs.logMuteConvo) as any,
          ),
          l.typedRef<ConvoDefs.LogUnmuteConvo>(
            (() => ConvoDefs.logUnmuteConvo) as any,
          ),
          l.typedRef<ConvoDefs.LogCreateMessage>(
            (() => ConvoDefs.logCreateMessage) as any,
          ),
          l.typedRef<ConvoDefs.LogDeleteMessage>(
            (() => ConvoDefs.logDeleteMessage) as any,
          ),
          l.typedRef<ConvoDefs.LogReadMessage>(
            (() => ConvoDefs.logReadMessage) as any,
          ),
          l.typedRef<ConvoDefs.LogAddReaction>(
            (() => ConvoDefs.logAddReaction) as any,
          ),
          l.typedRef<ConvoDefs.LogRemoveReaction>(
            (() => ConvoDefs.logRemoveReaction) as any,
          ),
        ],
        false,
      ),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
